export default __webpack_public_path__ + "static/media/account-check.9d180798.svg";